export const ROLES = {
  ADMIN: 'admin',
  TRAVEL_GUIDER: 'travelGuider',
  MAINTAINER: 'maintainer',
};

export const GPT_API_KEY =
  'sk-QXFcvGEpaMYNgIUjqZwN5sZ6vL_2NSGew3K4l-XP-4T3BlbkFJn7ZpLFHWSn0LqI3yz3thVBjoJsVwIzTrRGM1AnSokA';

export const CLIENT_ID = '62efe6ac-3208-4670-b3f5-d57efce7d3b6';

export const CLIENT_SECRET = 'c3f85fc2-0d3f-470b-9b4c-e320d956e112';
